import { render, staticRenderFns } from "./modalDialog.vue?vue&type=template&id=352c78b9&scoped=true"
import script from "./modalDialog.vue?vue&type=script&lang=js"
export * from "./modalDialog.vue?vue&type=script&lang=js"
import style0 from "./modalDialog.vue?vue&type=style&index=0&id=352c78b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c78b9",
  null
  
)

export default component.exports